import {DisplayDesktopTabs} from '../desktop/DescriptionTabs.jsx';
import {buildDescriptionTab, buildSpecificationTab} from './tabs/TabHelpers.jsx';
import {buildTabs3and4} from './tabs/Tab3And4Dynamic.jsx';
import {DisplayMobileTabs} from '../mobile/DescriptionTabsMobile.jsx';

export const BuildProductTabs = ({
                                   selectedVariant,
                                   variants,
                                   mediaTab,
                                   tabDescription,
                                   tabDescriptionTable,
                                   siteCollection,
                                   isMobile
                                 }) => {
  // console.log('[BuildProductTabs] selectedVariant: ', selectedVariant);
  const sku = selectedVariant?.sku;
  const category = selectedVariant?.category ?? siteCollection;

  const productMetafields = selectedVariant?.metafields;
  if (!productMetafields || productMetafields?.length === 0) return null;

  const metaData = productMetafields?.reduce((a, node) => {
    a[node.key] = node;
    return a;
  }, {});
  // console.log("[BuildProductTabs] metaData: ", metaData);
  metaData.description = tabDescription;
  metaData.descriptionTable = tabDescriptionTable;

  let tabNames = ['Description', 'Specifications'];
  let tabsData = [buildDescriptionTab(metaData, selectedVariant), buildSpecificationTab(metaData)];

  const {tabNames3and4, tabsData3and4} = buildTabs3and4(
    sku,
    metaData,
    category,
    mediaTab,
    selectedVariant,
    variants
  );
  // console.log(tabNames3and4, tabsData3and4);

  if (tabNames3and4 && tabNames3and4?.length > 0) {
    tabNames = [...tabNames, ...tabNames3and4];
    tabsData = [...tabsData, ...tabsData3and4];
  }

  const tabsDataForMobile = tabsData?.map((tab, index) => {
    return <div key={index}>{tab}</div>;
  });

  return (
    <>
      {isMobile && <DisplayMobileTabs tabNames={tabNames} sections={tabsDataForMobile} />}
      {!isMobile && <DisplayDesktopTabs tabNames={tabNames} sections={tabsData} />}
    </>
  );
};
